// extracted by mini-css-extract-plugin
export default {"modal":"common-team-members-modal_modal__N7wAA","close-btn":"common-team-members-modal_close-btn__f951t","closeBtn":"common-team-members-modal_close-btn__f951t"};